import axios from "@/axios"

const url = "/api/encaste/posturas"

class PosturePeriodsService {
	async getPeriodsByPadrillo(id) {
		try {
			const { data } = await axios.get(`${url}/get-periods-by-padrillo/${id}`)
			return data
		} catch (err) {
			console.error(err)
		}
	}
	async getPosturesByPeriod(id) {
		try {
			const { data } = await axios.get(`${url}/get-postures-by-period/${id}`)
			return data
		} catch (err) {
			console.error(err)
		}
	}
	async getInseminationsByPeriod(id) {
		try {
			const { data } = await axios.get(`${url}/get-inseminations-by-period/${id}`)
			return data
		} catch (err) {
			console.error(err)
		}
	}
}
export default new PosturePeriodsService()
